// recebe uma string dd/mm/aaaa e retorna um objeto data

export default function construirData(data) {
  const [dia, mes, ano] = data.split("/");
  return new Date(ano, parseInt(mes) - 1, dia);
}
